import axios from 'axios';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/organization/family_subsidy_custom_views`;
  },

  create(attributes, familySubsidyProgramId) {
    return axios
      .post(this.baseUrl(), {
        data: {
          type: 'custom_view',
          attributes,
          relationships: {
            family_subsidy_program: {
              data: {
                type: 'family_subsidy_program',
                id: familySubsidyProgramId,
              },
            },
          },
        },
      })
      .catch(handleError);
  },

  destroy(id) {
    return axios.delete(`${this.baseUrl()}/${id}`);
  },

  index(filters) {
    return axios.get(this.baseUrl(), { params: filters });
  },

  get(id) {
    return axios.get(`${this.baseUrl()}/${id}`);
  },

  update(id, attributes, relationships) {
    return axios
      .patch(`${this.baseUrl()}/${id}`, {
        data: {
          id,
          type: 'custom_view',
          attributes,
          relationships,
        },
      })
      .catch(handleError);
  },
};
